import React from "react";

const Skill = ({ skill }) => {
  return (
    <div className="col-md-6">
      <div className="expertise-item">
        <i className="bi bi-check-circle-fill me-2"></i>
        {skill}
      </div>
    </div>
  );
};

export default Skill;
